var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { Container } from "./styled/cluster-popup";

function ClusterPopup(_a) {
  var _b = _a.offsetX,
      offsetX = _b === void 0 ? 0 : _b,
      _c = _a.offsetY,
      offsetY = _c === void 0 ? -25 : _c,
      props = __rest(_a, ["offsetX", "offsetY"]);

  return React.createElement(Container, __assign({
    offsetX: offsetX,
    offsetY: offsetY
  }, props));
} // TODO: Using default props here as search marker relies on them.
// TODO: Codesmelly, fix later
// TODO: See src\components\search-map\SearchMarker.js:15,16


ClusterPopup.defaultProps = {
  offsetX: 0,
  offsetY: -25
};
export default ClusterPopup;